<template>
  <div
    class="pb-12 max-w-lg mx-auto"
  >
    <h2>Assessor {{ assessor.assessor_id }}</h2>
    <h3 class="mt-4 mb-2">
      Application Feedback
    </h3>
    <div
      class="italic leading-loose"
      v-html="parseMarkdown(assessor.interview_feedback || '')"
    />
  </div>
</template>

<script>
export default {
  name: 'AssessorFeedbackSingle',
  props: {
    assessor : {
      type: Object,
      required: true
    }
  }
}
</script>